export default __webpack_public_path__ + "static/Anthony-56e6f62d925df8949fa80b8f6fba4a2b.jpeg";